import React, { useState } from 'react';

import DropdownWrapper from '@components/common/dropdown_wrapper/main';
import { getAvailableLanguages } from '@components/asset/modal/tabs/edit/helpers';
import {
  determineCurrentLanguage,
  findCurrentLanguageInMap,
  Locale,
} from '@components/common/language_menu/languagesMap';
import LanguageMenuDropdown from '@components/common/language_menu/LanguageMenuDropdown';
import {
  UpdateUserViewOptions,
  UserViewOptionsKeys,
} from '@components/show_page/sections/view_options/ViewOptionTypes';


interface ViewOptionsLanguagesProps {
  activeLocale: Locale;
  isActiveLocaleInLocalStorage: boolean;
  updateUserViewOptions: UpdateUserViewOptions;
}

const ViewOptionsLanguages = ({
  activeLocale,
  isActiveLocaleInLocalStorage,
  updateUserViewOptions,
}: ViewOptionsLanguagesProps): JSX.Element => {
  const handleUpdateLocale = (locale: Locale): boolean => {
    // only update locale IF selected locale is different from active locale
    // OR selected locale is not in local storage
    if (locale !== activeLocale || !isActiveLocaleInLocalStorage) {
      updateUserViewOptions(UserViewOptionsKeys.SelectedUGTLocale, locale);
      return true;
    }

    return false;
  };

  return (
    <LanguageMenuDropdown
      copy={t('Display asset info and tags in one of the following languages.')}
      defaultLocale={BFG.locales.ugtLocaleDefault}
      onLocaleChange={handleUpdateLocale}
      openOnClick={false}
      selectedLocale={activeLocale}
    />
  );
};

export default ViewOptionsLanguages;
